<template>
  <div>
    <BaseTableCell
      v-if="item.originalOrder"
      v-test="'hasOriginalOrder'"
    >
      <BaseText
        target="_blank"
        @click="orderPdfRoute(item.orderId)"
        :iconBefore="orderPdfIcon() === 'pdf' ? 'pdf' : 'eye'"
      >
        {{ $t('products.reason_credited', { orderNumber: item.orderNumber }) }}
      </BaseText>
    </BaseTableCell>
    <BaseTableCell
      v-else-if="item.orderId"
      v-test="'hasOrderId'"
    >
      <BaseText
        @click="orderPdfRoute(item.orderId)"
        v-test="'product-order-link'"
        :iconBefore="orderPdfIcon() === 'pdf' ? 'pdf' : 'eye'"
      >
        {{ $t('products.reason_sold', { orderNumber: item.orderNumber }) }}
      </BaseText>
    </BaseTableCell>
    <BaseTableCell v-else-if="item.stockOrderId">
      <BaseText
        :routerLink="{
          name: isOpen ? 'products-order-build' : 'stock-order',
          params: { stockOrderId: item.stockOrderId }
        }"
      >
        {{ item.reason }}
      </BaseText>
    </BaseTableCell>
    <BaseTableCell
      v-else-if="
        item.type === 'create_action' || item.type === 'product_import'
      "
    >
      {{ $t(`products.${item.type}`) }}
    </BaseTableCell>
    <BaseTableCell
      v-else
      v-test="'isPreSelectedReason'"
    >
      {{ isPreSelectedReason }}
    </BaseTableCell>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { orderPdfIcon, orderPdfRoute } from '@/helpers/order-pdf-route';

export default defineComponent({
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      orderPdfRoute,
      orderPdfIcon,
    };
  },
  computed: {
    isOpen() {
      return (
        this.item.stockOrderStatus && this.item.stockOrderStatus === 'open'
      );
    },
    isPreSelectedReason() {
      const options = [
        'no_reason',
        'salon_usage',
        'gift',
        'damage',
        'new_stock',
      ];
      const item = this.item.reason;
      const isPartOfOptions = options.includes(item);

      if (item && isPartOfOptions) {
        return this.$t(`products.reasons.${item}`);
      } else if (item) {
        const trimmed = `${item.substring(0, 48)}..`;
        return item.length > 50 ? trimmed : item;
      } else {
        return '-';
      }
    },
  },
});
</script>
